module.exports = __webpack_public_path__ + "img/icon-page-left.4e46ab97.svg";